import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            fontSize: '18px',
            fontWeight: 600,
            marginBottom: theme.spacing(1),
        },
    })
);
